import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {
  GetDuplicateClaimsDto
} from "../../../auto-generated-server-dtos/claim/duplicate-detection/get-duplicate-claims-dto";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class GetDuplicateClaimsService {
  constructor(private httpClient: HttpClient) {
  }

  getDuplicateClaims(claimId: number) {
    return this.httpClient.get<GetDuplicateClaimsDto>(`${environment.apiServer}/Claim/GetDuplicateClaims`, {params: {claimId: claimId}});
  }
}
